import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { ParametersService } from '@app/components/parameters/parameters.service';
import { first } from 'rxjs';

@Component({
    selector: 'app-idp-login-redirect',
    templateUrl: './idp-login.component.html',
    styleUrl: './idp-login.component.scss'
})
export class IdpLoginRedirectComponent implements OnInit {
    private readonly authService = inject(AuthService);
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly parametersService = inject(ParametersService);

    private getRedirectTarget(): string {
        return this.parametersService.resolveLoginRedirectTarget(
            this.route.snapshot.queryParams['returnUrl']
        );
    }

    private getLoginRedirectTarget(): string {
        return this.parametersService.storeLoginRedirectTarget(
            this.route.snapshot.queryParams['returnUrl']
        );
    }

    private startAuthFlow(): void {
        const screenHint = this.route.snapshot.data?.['screenHint'] as string | undefined;

        this.authService.loginWithRedirect({
            appState: {
                target: this.getLoginRedirectTarget()
            },
            ...(screenHint ? { authorizationParams: { screen_hint: screenHint } } : {})
        }).subscribe();
    }

    ngOnInit(): void {
        // Immediately redirect the browser back to Auth0/IdP for IDP-initiated login.
        this.authService.isAuthenticated$.pipe(first()).subscribe({
            next: (isAuthenticated) => {
                if (isAuthenticated) {
                    this.router.navigateByUrl(this.getRedirectTarget());
                    return;
                }

                this.startAuthFlow();
            },
            error: () => {
                // If we cannot read auth state, still attempt to start the Auth0 flow.
                this.startAuthFlow();
            }
        });
    }
}

